var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4",staticStyle:{"height":"100vh"}},[_c('iframe',{attrs:{"src":_vm.href,"frameborder":"0","width":"100%","height":"100%","id":"print-iframe"}})])}
var staticRenderFns = []

export { render, staticRenderFns }